import script from "./balance-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./balance-page.vue?vue&type=script&lang=ts&setup=true"

import "./balance-page.vue?vue&type=style&index=0&id=436ec132&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-436ec132"]])

export default __exports__